angular.module('aprima-core-ui')
    .directive('apAndroidHeightFix', ['$interval', function($interval) {
    'use strict';

    return {
        restrict: 'A',
        link: function(scope, element){
            var cancelUpdate = false;

            element.css('min-height', '101%');

            function updateVisibility(){
                var totalHeight = 0;
                var parentHeight = $('body').height();

                element.children().each(function(){
                    totalHeight = totalHeight + $(this).outerHeight();
                });

                if(totalHeight > parentHeight){
                    $('body').css('overflow', 'visible');
                }
                else{
                    $('body').css('overflow', 'hidden');
                }
            }

            var widthWatch = $interval(function(){
                // Even after calling $interval.cancel()
                // on the promise that $interval returns,
                // this method can still get called at least once.
                // That would cause it to get set to "overflow: visible" in the $destroy,
                // and then get reset to "overflow:hidden" after because of this method call.
                // To handle this race condition, check "cancelUpdate" to see whether
                // to proceed further in this method.
                if(cancelUpdate) {
                    return;
                }

                updateVisibility();
            }, 50);

            scope.$on('$destroy', function(){
                cancelUpdate = true;
                $interval.cancel(widthWatch);
                $('body').css('overflow', 'visible');
            });
        }
    };
}]);